import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Router } from '@monash/portal-react';
import {
  MegaWrapper,
  AuthProvider,
  ImpersonationWrapper,
  APIProvider,
  MenuProvider,
  accessControl,
  LoadingScreen,
  FeatureProvider,
  AccessibilityProvider,
  NotificationProvider,
  MaintenanceProvider,
  ChatBotWrapper,
  MockProvider,
  DemoProvider,
} from '@monash/portal-frontend-common';
import { FEATURES, FEATURE_FLAGS } from './constants/features';
import StudentProvider from './components/providers/StudentProvider';
import SnackbarProvider from './components/providers/SnackbarProvider';
import homeLoading from './assets/lotties/home-loading.json';
import App from './App';
import './index.css';
import initMonitoring from './initMonitoring';

const env = import.meta.env.VITE_ENV;
if (import.meta.env.VITE_ENV !== 'local') {
  initMonitoring(env);
}

const container = document.getElementById('root');
const root = createRoot(container);
const fakeData = JSON.parse(sessionStorage.getItem('fakeData') || false);

const loadingScreen = <LoadingScreen animation={homeLoading} />;
const wrappers = [
  {
    comp: FeatureProvider,
    props: {
      defaultFeatureFlags: FEATURE_FLAGS,
    },
  },
  {
    comp: AuthProvider,
    props: {
      nolanding: true,
      loadingPage: loadingScreen,
      accessControl: (user, featureFlags) =>
        accessControl.isStudent(user) ||
        accessControl.isDemoUser(featureFlags?.DEMO_MODE),
      useMocks: FEATURES.FORCE_MOCK_API
        ? import.meta.env.VITE_ENV !== 'prod'
        : fakeData,
      getPreferences: true,
    },
  },
  React.StrictMode,
  {
    comp: MockProvider,
    props: {
      useMocks: FEATURES.FORCE_MOCK_API
        ? import.meta.env.VITE_ENV !== 'prod'
        : fakeData,
    },
  },
  APIProvider,
  DemoProvider,
  ImpersonationWrapper,
  MaintenanceProvider,
  ChatBotWrapper,
  StudentProvider,
  MenuProvider,
  Router,
  AccessibilityProvider,
  SnackbarProvider,
  NotificationProvider,
];

root.render(
  <MegaWrapper providers={wrappers}>
    <App />
  </MegaWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
